import { useState, useEffect } from "react";
import Modal from "@material-ui/core/Modal";
import { useFormik } from "formik";
import {
  FaWallet,
  FaShieldAlt,
  FaTimes,
  FaInfoCircle,
  FaComments,
  FaWhatsapp,
} from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import {
  clearCreatePaymentSuccess,
  createPaymentRequest,
} from "../../redux/action";
import { toast } from "react-toastify";
import CurrencyDisplay from "../Currency/CurrencyDisplay";
import { PageOne } from "./PageOne";
import { PageTwo } from "./PageTwo";
import { ArrowBack } from "@mui/icons-material";

export const Deposite = ({ isHome }) => {
  const [pages, setPages] = useState(0);
  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);
  const handleOpen = () => setOpen(true);

  const [selectedToken, setSelectedToken] = useState({
    tokenName: "",
    logopath: "",
    address: "",
    network: "",
  });

  const [amount, setAmount] = useState(0);
  const [usdAmount, setUsdAmount] = useState(0);

  const dispatch = useDispatch();

  const {
    user,
    createPaymentLoading,
    createPaymentSuccess,
    createPaymentError,
  } = useSelector((state) => {
    const {
      success: { createPayment: createPaymentSuccess },
      errors: { createPayment: createPaymentError },
    } = state.ajaxStatuses;
    const { createPaymentLoading } = state.loadingIndicator;
    const { user } = state.userData;

    return {
      user,
      createPaymentLoading,
      createPaymentSuccess,
      createPaymentError,
    };
  });

  const formik = useFormik({
    initialValues: {
      type: "Deposite",
      fundAmount: "",
      imgReceiptUrl: "",
      transactionRef: "",
    },
    onSubmit: (prop) => {
      if (prop.imgReceiptUrl === "" && prop.transactionRef === "") {
        toast.error(
          "Please upload a receipt or enter a transaction reference ID",
          {
            duration: 4000,
          },
        );
      } else {
        prop.user = user._id;
        prop.email = user.email;
        prop.userName = user.userName;
        prop.fundAmount = usdAmount;
        dispatch(createPaymentRequest(prop));
      }
    },
  });

  useEffect(() => {
    if (createPaymentError) toast.error(createPaymentError);
    if (createPaymentSuccess) {
      toast.success(createPaymentSuccess);
      handleClose();
      dispatch(clearCreatePaymentSuccess());
    }
  }, [createPaymentError, createPaymentSuccess, dispatch]);

  const componentArray = [
    <PageOne
      pages={pages}
      setPages={setPages}
      selectedToken={selectedToken}
      setSelectedToken={setSelectedToken}
      amount={amount}
      setAmount={setAmount}
      usdAmount={usdAmount}
      setUsdAmount={setUsdAmount}
    />,
    <PageTwo
      pages={pages}
      setPages={setPages}
      selectedToken={selectedToken}
      amount={amount}
      setAmount={setAmount}
      formik={formik}
      createPaymentLoading={createPaymentLoading}
      usdAmount={usdAmount}
    />,
  ];

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="h-screen w-full flex justify-center outline-0 transition duration-500 "
      >
        <div
          className="container mx-auto max-w-2xl pt-0 pb-32 md:pb-12 max-h-screen overflow-y-scroll"
          style={{
            backgroundImage: "url('/img/new/background/transactionbg.jpeg')",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        >
          {/* Close Modal Header */}
          <div className="flex fixed w-full max-w-2xl z-10 bg-white px-4 justify-between items-center py-4 border-b border-gray-100">
            <button
              onClick={handleClose}
              className="p-2 hover:bg-gray-100 rounded-full transition-colors duration-200 group"
              aria-label="Close modal"
            >
              <ArrowBack className="w-5 h-5 group-hover:text-gray-600" />
            </button>
            <h2 className="text-lg font-semibold text-gray-900">
              Deposit Funds
            </h2>
          </div>

          {/* Top Balance Widget */}
          {user && (
            <div className="mt-24 mx-2 from-slate-900 to-slate-800 rounded-xl p-4 mb-4 text-black shadow-[0_0_20px_rgba(0,0,0,0.1)] flex items-center justify-between">
              <div>
                <p className="text-primary text-xs font-semibold uppercase tracking-wider mb-1">
                  Current Balance
                </p>
                <h3 className="text-3xl font-heading font-semibold ">
                  <CurrencyDisplay usdAmount={user.balance} />
                </h3>
              </div>
              <div className="w-12 h-12 bg-primary rounded-xl flex items-center justify-center backdrop-blur-sm">
                <FaWallet className="text-xl text-white" />
              </div>
            </div>
          )}

          <div class="max-w-md w-full mx-2 bg-white mb-4 rounded-lg p-4 shadow-sm border border-gray-100">
            <div class="flex items-start gap-4 mb-6">
              <div class="bg-blue-600 rounded-full p-1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="white"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <line x1="12" x2="12" y1="16" y2="12" />
                  <line x1="12" x2="12.01" y1="8" y2="8" />
                </svg>
              </div>
              <h2 class="text-2xl font-semibold text-blue-700 tracking-tight">
                Deposit Instructions
              </h2>
            </div>

            <p class="text-gray-600 leading-relaxed mb-8">
              To ensure accuracy and security, deposit details are provided
              directly by our support team. Before making a deposit, please
              contact our official support channels to receive the correct
              payment instructions for your account.
            </p>

            <div class="relative flex items-center mb-8">
              <div class="flex-grow border-t border-gray-100"></div>
              <span class="flex-shrink mx-4 text-blue-700 font-semibold text-lg">
                How to Proceed
              </span>
              <div class="flex-grow border-t border-gray-100"></div>
            </div>

            <div class="space-y-4 mb-8">
              <button class="w-full flex items-center justify-between p-2 border border-gray-100 rounded-2xl hover:bg-gray-50 transition-colors group">
                <div class="flex items-center gap-4">
                  <div class="bg-blue-50 p-3 rounded-2xl">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="28"
                      height="28"
                      viewBox="0 0 24 24"
                      fill="#2563eb"
                      stroke="none"
                      class="opacity-80"
                    >
                      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                      <circle cx="8" cy="10" r=".5" fill="white" />
                      <circle cx="12" cy="10" r=".5" fill="white" />
                      <circle cx="16" cy="10" r=".5" fill="white" />
                    </svg>
                  </div>
                  <div class="text-left">
                    <p class="text-gray-800 font-semibold text-sm">
                      Contact our Support Team
                    </p>
                    <p class="text-gray-500 text-xs">via the in-app chat</p>
                  </div>
                </div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="text-gray-400 group-hover:text-gray-600"
                >
                  <path d="m9 18 6-6-6-6" />
                </svg>
              </button>

              <button class="w-full flex items-center justify-between p-2 border border-gray-100 rounded-2xl hover:bg-gray-50 transition-colors group">
                <div class="flex items-center gap-4">
                  <div class="bg-blue-50 p-3 rounded-2xl">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="28"
                      height="28"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#2563eb"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="opacity-80"
                    >
                      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                    </svg>
                  </div>
                  <div class="text-left">
                    <p class="text-gray-800 font-semibold text-sm">
                      Or reach us through
                    </p>
                    <p class="text-gray-500 text-xs">WhatsApp or Telegram</p>
                  </div>
                </div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="text-gray-400 group-hover:text-gray-600"
                >
                  <path d="m9 18 6-6-6-6" />
                </svg>
              </button>
            </div>

            <div class="bg-blue-50/50 p-5 rounded-xl flex gap-4">
              <div class="mt-1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#2563eb"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z" />
                  <path d="M5 3v4" />
                  <path d="M3 5h4" />
                </svg>
              </div>
              <p class="text-blue-700 text-[15px] font-medium leading-snug">
                This approach helps prevent errors and ensures your deposit is
                correctly credited to your account.
              </p>
            </div>
          </div>

          <div class="max-w-md w-full mx-2 mb-4 bg-[#FFF9F0] rounded-lg p-4 border border-orange-100 shadow-sm">
            <div class="flex items-center gap-4 mb-6">
              <div class="bg-[#E67E22] rounded-full p-2 flex items-center justify-center shadow-sm">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="white"
                  stroke-width="2.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                  <path d="m9 12 2 2 4-4" />
                </svg>
              </div>
              <h2 class="text-2xl font-semibold text-[#AD5B15] tracking-tight">
                Important Notice
              </h2>
            </div>

            <div class="space-y-4 mb-8">
              <p class="text-[#4A3F35] text-[17px] leading-relaxed font-medium">
                Only follow deposit instructions provided directly by{" "}
                <span class="text-black font-semibold">
                  Africa's Trusted Digital Platform
                </span>{" "}
                support through official channels.
              </p>
              <p class="text-[#4A3F35] text-[17px] leading-relaxed font-medium">
                Deposits made without confirmation may result in delays or
                processing issues.
              </p>
            </div>

            <div class="border-t border-orange-200/50 mb-6"></div>

            <div class="pr-8">
              <p class="text-[#AD5B15] text-md font-bold leading-tight">
                Our support team is available 24/7 to assist you.
              </p>
            </div>
          </div>

          {/* Main Card */}
          <div className="bg-white rounded-3xl shadow-xl shadow-gray-200/50 overflow-hidden border border-gray-100">
            {/* Header & Progress */}
            <div className="bg-white p-6 border-b border-gray-100">
              <div className="flex items-center justify-between mb-6">
                <h2 className="text-xl font-heading font-semibold text-gray-900">
                  {pages === 0 ? "Select Method" : "Complete Payment"}
                </h2>
                <div className="flex items-center gap-2 text-green-600 text-xs font-semibold bg-green-50 px-3 py-1 rounded-full">
                  <FaShieldAlt /> Secure
                </div>
              </div>

              {/* Progress Bar */}
              <div className="relative h-2 bg-gray-100 rounded-full overflow-hidden">
                <div
                  className="absolute top-0 left-0 h-full bg-primary transition-all duration-500 ease-out"
                  style={{ width: pages === 0 ? "50%" : "100%" }}
                ></div>
              </div>
              <div className="flex justify-between mt-2 text-xs font-semibold text-gray-400 uppercase tracking-wide">
                <span className={pages >= 0 ? "text-primary" : ""}>
                  Step 1: Details
                </span>
                <span className={pages >= 1 ? "text-primary" : ""}>
                  Step 2: Transfer
                </span>
              </div>
            </div>

            {/* Dynamic Content */}
            <div className="transition-all duration-300">
              {componentArray[pages]}
            </div>
          </div>

          <p className="text-center text-xs text-gray-400 mt-8 font-body">
            Deposits are processed automatically after network confirmation.
          </p>
        </div>
      </Modal>
      <div onClick={handleOpen}>
        <div className="bg-white rounded-[1.25rem] py-3 px-2 flex flex-col items-center text-center   cursor-pointer hover:bg-blue-50/50 transition-colors active:scale-95">
          <div className="w-12 h-12 rounded-full bg-[#f0f4ff] flex items-center justify-center text-[#1a4bdf] mb-3 relative">
            <svg
              width="22"
              height="22"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="12" y1="1" x2="12" y2="23"></line>
              <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
            </svg>
            <div className="absolute bottom-0 right-0 w-4 h-4 bg-[#1a4bdf] text-white rounded-full flex items-center justify-center border-2 border-white">
              <svg
                width="10"
                height="10"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="4"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="12" y1="5" x2="12" y2="19"></line>
                <line x1="5" y1="12" x2="19" y2="12"></line>
              </svg>
            </div>
          </div>
          <h4 className="text-[13px] font-semibold text-slate-800 mb-1">
            Fund
          </h4>
          <p className="text-[10px] text-slate-500 font-medium leading-tight">
            Add money
          </p>
        </div>
      </div>
    </>
  );
};
